export const ASSETS = 'assets';
export const ASSETS_DOCS = 'docs';
export const AUTHORS_AVATAR = 'assets/authors';
export const E_BOOKS_COVER = 'assets/ebooks';
export const PROMO_PRODUCTS_IMG = 'assets/promoProducts';
export const ASSETS_BRANDS = 'brands';


